(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (() => {
    const media = window.matchMedia('(min-width: 990px)');
    const sortSelect = document.querySelector('[data-collection-sort]');

    const syncFilterDisclosure = () => {
      document.querySelectorAll('.filters__details').forEach((details) => {
        details.open = media.matches;
      });
    };

    syncFilterDisclosure();
    media.addEventListener('change', syncFilterDisclosure);

    if (sortSelect) {
      sortSelect.addEventListener('change', () => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', sortSelect.value);
        url.searchParams.delete('page');
        window.location.assign(url.toString());
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
